/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './whitelabel';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "person": {
        "nested": {
          "app_data": {
            "nested": {
              "AppData": {
                "fields": {
                  "whiteLabelOptions": {
                    "type": ".squareup.person.whitelabel.WhiteLabelOptions",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.person?.nested?.app_data?.nested?.AppData) {
  $root.addJSON(jsonData);
}

/**
 * Holds app specific data attached to a Person profile.
 *
 * SOURCE AppData @ squareup/person/app_data.proto at 18:1
 */
export const AppData = $root.lookupType('squareup.person.app_data.AppData');
fixType(AppData);
Builder.createAndAttachToType(AppData);